<template>
  <div class="flex items-center gap-4" data-test-id="date-range-picker">
    <div class="flex items-center gap-2">
      <DatePicker
        id="start-date-picker"
        v-model="startDate"
        :manualInput="true"
        showIcon
        dateFormat="mm/dd/yy"
        placeholder="Start Date"
        data-test-id="start-date-picker"
        size="small"
      />
    </div>
    <div class="flex items-center gap-2">
      <DatePicker
        id="end-date-picker"
        v-model="endDate"
        :manualInput="true"
        showIcon
        dateFormat="mm/dd/yy"
        placeholder="End Date"
        data-test-id="end-date-picker"
        size="small"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import DatePicker from 'primevue/datepicker'
import { useSearchStore } from '@/stores/searchStore'

const searchStore = useSearchStore()

const startDate = computed<Date | null>({
  get: () => searchStore.currentDateRange.startDate,
  set: value => {
    searchStore.currentDateRange.startDate = value
  },
})

const endDate = computed<Date | null>({
  get: () => searchStore.currentDateRange.endDate,
  set: value => {
    searchStore.currentDateRange.endDate = value
  },
})
</script>
